/*External dependencies */
import update from 'immutability-helper';

/* Local dependencies */
import { ListUsersActions, ListUsersActionTypes, resultType } from './action';

export interface ListUsersStste {
  isListUsersModalOpen: boolean;
  isListUsersLoading: boolean;
  result: resultType;
  error: string;
}

export const initialListUsersState: ListUsersStste = {
  isListUsersModalOpen: false,
  isListUsersLoading: false,
  result: {
    total: 0,
    users: [],
  },

  error: '',
};

export function listUsersReducer(state = initialListUsersState, action: ListUsersActions) {
  switch (action.type) {
    case ListUsersActionTypes.OPEN_LIST_USERS_MODAL:
      return update(state, {
        isListUsersModalOpen: { $set: true },
      });
    case ListUsersActionTypes.CLOSE_LIST_USERS_MODAL:
      return update(state, {
        isListUsersModalOpen: { $set: false },
        result: {
          users: { $set: null },
          total: { $set: null },
        },
      });
    case ListUsersActionTypes.LIST_USERS_REQUEST:
      return update(state, {
        isListUsersLoading: { $set: true },
      });
    case ListUsersActionTypes.LIST_USERS_SUCCEEDED:
      return update(state, {
        isListUsersLoading: { $set: false },
        result: {
          users: { $set: action.result.users },
          total: { $set: action.result.total },
        },
      });
    case ListUsersActionTypes.LIST_USERS_FAILED:
      return update(state, {
        isListUsersLoading: { $set: false },
        error: { $set: action.error },
      });
    default:
      return state;
  }
}
